<template>
  <b-container class="my-5">
    <div class="sub-header-text mb-3">Our Brands</div>
    <b-row :class="['px-3 px-lg-0', { 'justify-content-between': formattedBrands.length >= 4 }]">
      <b-col
        v-for="(brand, key) in formattedBrands"
        :key="key"
        cols="6"
        sm="4"
        lg="auto"
        class="mb-3 mb-lg-0 cursor-pointer"
        @click="goToBrand(brand.uuid)"
      >
        <div class="brand-image-container">
          <b-img :src="brand.logo" fluid alt="Brand" />
        </div>
        <div class="fw-bold mt-3 brand-name">
          {{ brand.name }}
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapGetters({
      homeWebLayout: "design/homeWebLayout"
    }),
    ...mapState("merchant", {
      subdomain: state => state.subdomain
    }),
    ...mapState("customer", {
      location: (state) => state.location,
    }),
    formattedBrands: {
      get() {
        return Object.keys(this.homeWebLayout).length > 0 &&
          this.homeWebLayout.our_brands
          ? JSON.parse(this.homeWebLayout.our_brands)
          : [];
      },
      set(ourBrands) {
        return ourBrands;
      }
    }
  },
  methods: {
    goToBrand(uuid) {
      if (!this.location) {
        window.scrollTo(0, 0);
      } else {
        this.$router.push({ name: "Brands", params: { subdomain: this.subdomain, uuid: uuid } });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.brand-image-container {
  height: 139.15px;
  width: 139.15px;
  border: 1.7px solid #e9ebed;
  border-radius: 33.99px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 19.3px;
}
.brand-name {
  max-width: 139.15px;
}
</style>
